<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.rows") }}</label>
          <el-slider
            v-model="row"
            :step="3"
            :min="14"
            :max="20"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.cols") }}</label>
          <el-slider
            v-model="col"
            :step="1"
            :min="2"
            :max="3"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{
            $t("module.letter_count")
          }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="5"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        class="content-rows"
        style="
          display: flex;
          flex-direction: row;
          flex: 1;
          height: 100%;
          width: 100%;
          flex-wrap: wrap;
        "
      >
        <div
          class="content-col"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          "
          v-for="(c, cIndex) in col * row"
          :style="{ width: wrapper.width / col + 'px' }"
        >
          <span
            style="padding: 0px 10px; border-radius: 10px"
            class="dark-inverted"
            :style="{
              fontSize: fontModifier + 'px',
              lineHeight: getLineHeight + 'px',
              color: c == step ? 'white !important' : '',
              backgroundColor: c == step ? 'orange' : '',
            }"
            v-if="currentWords[c - 1]"
          >
            {{
              currentWords[c - 1].charAt(0).toLocaleUpperCase() +
              currentWords[c - 1].slice(1)
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import content from "./words";
import level1 from "./level1";
import level2 from "./level2";
import level3 from "./level3";
import level4 from "./level4";
import level5 from "./level5";
import level6 from "./level6";
import level7 from "./level7";
import words_ru from "./words_ru";
import _ from "lodash";
export default {
  name: "IkiliUcluBlok",
  props: ["config"],
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      level: 1,
      col: 2,
      row: 14,
      wrapper: {
        width: 0,
        height: 0,
      },
      step: 1,
      words: [
        [
          ...level1
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level2
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level3
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level4
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level5
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level6
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
        [
          ...level7
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != ""),
        ],
      ],
      currentWords: [],
      interval: null,
      settings: false,
      autoLevel: 0,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.words[this.level - 1];
    this.start(true);
  },
  methods: {
    start(shuffle) {
      if (shuffle) this.currentWords = _.shuffle(this.words[this.level - 1]);

      this.interval = setInterval(() => {
        if (this.pause) return;
        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        if (this.step == this.getMaxCount) {
          this.currentWords = _.shuffle(this.words[this.level - 1]);
          this.step = 1;
          return;
        }
        this.step += 1;
      }, this.currentSpeed);
    },
  },
  computed: {
    getLineHeight() {
      return this.wrapper.height / this.row;
    },
    getMaxCount() {
      return this.col * this.row;
    },
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
    fontModifier() {
      var baseSize = 22;
      if (this.col == 3 && this.level == 5) {
        return baseSize - 7;
      }
      if (this.col == 3 && this.level == 4) {
        return baseSize - 5;
      }
      return baseSize;
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    level: function () {
      this.step = 1;
      clearInterval(this.interval);
      this.start(true);
    },
    row: function () {
      this.step = 1;
      clearInterval(this.interval);
      this.start(true);
    },
    col: function () {
      this.step = 1;
      clearInterval(this.interval);
      this.start(true);
    },
    step: function () {
      if (this.autoLevel == 0) return;
      if (this.step == this.getMaxCount) {
        this.speed = Math.min(
          this.speed + 1,
          this.config && this.config.max_speed
            ? this.config.max_speed
            : this.speeds.length
        );
      }
      if (this.speed > 4 && this.step == this.getMaxCount) {
        this.col = Math.min(
          this.col + 1,
          this.config && this.config.max_col ? this.config.max_col : 3
        );
        this.row = Math.min(
          this.row + 3,
          this.config && this.config.max_row ? this.config.max_row : 23
        );
        this.level = Math.min(
          this.level + 1,
          this.config && this.config.max_level ? this.config.max_level : 5
        );
      }
    },
  },
  created() {
    var az = `düşünürəm,gedirsən,bəyaz,qardaşım,adamın,hərhansı,çalışıram,dayanın,azından,gələn,zarafat,yaşlı,başladı,gəlib,razı,verin,yolunda,telefon,hərəkət,həyatda,gəlir,kimin,beləcə,şeyin,sürü,üstünə,dəqiq,dostum,atan,kifayət qədər,el,arada,gözlənti,mövzusunda,yaxın,verdi,içəri,silah,şeyə,çıxdı,hamısını,güclü,sual,hər şey,qəribə,başa düşdün,elə bilirsən,qısa,çıx,işləyir,sağol,gəldin,ötürün,otur,yaxşıyam,başa düşdüm,edəcəyəm,pulu,hətta,vəziyyətdə,qızı,haqlısan,olduğuna,uyğun,qorxunc,qayıt,gəlirəm,növ,görəsən,bacarmaram,qan,etdiyini,aid,nəyi,dəfə,şeyləri,belə,çək,deyil,arasında,aşağı,bimək,verirəm,diqqətli,varsa,nəyin,ehtimal,dünyanın,sevindim,dolu,keçdi,narahat,yaxında,ehtiyacı,nəydi,verdim,qəribə,davamlı,olacağını,ortaya,anan,deyirsən,milyon,yüksək,at,yuxarı,fikir,olmadı,zamanda,xaricində,hiss edrəm,bilmirdim,bizimlə,cənab,sizinlə,aldı,lənətə gəlmiş,dedin,dəli,olmayacaq,olmadan,sənsən,yalnızca,acı,gətir,bağışlayasınız,qızlar,and,edirsən,tut,ölü,xoşluqla,üzrə,gizli,burda,ehtiyacın,eşq,etməyə,şirin,edəcəyik,edəcək,təxminən,çöldə,içinə,olmağı,birinin,ər,xəstə,yavaş,ölüm,səssiz,eşitdin,olurdu,ehtiyacımız,istərsən,hərşeyi,edirəm,mümkün,edəcək,it,lazım olduğunu,bərbad,bəxt,edən,ehtimal edirdim,sədr,isti,zərər,dək,hadisə,edər,oradan,gedin,qəhvə,görünürsən,ana,nəfəs,bağışlayasınız,mahnı,bilmərəm,etməyə,sadə,vermək,üstünə,deyir,olub,görürəm,qalx,evinə,yeddi,film,istədi,başa düşüldü,istəyərəm,insanlar,olmayan,sevgili,kaş ki,ildir,var imiş,insanların,alın,olmalısan,hər halda,qızım,zibil,buradayam,yazıq,oxşayır,hər kəsin,səsini,istədiyini,normal,nəyə,birinə,dalğa,tanış,aldın,etdin,zamandır,bilmir,eyni,çarli,çəkil,unutma,baş,səfər,möhtəşəm,görür,deyirəm,üz  yüz,tərcümə,kiçik,millət,yeri,olacaqsan,kifayət,edəcəksən,xəta,bununla,pis,ailə,önündə,dedin,sevginə,nömrə,düşün,məlum,ala bilər,deyirəm,demişdim,evi,bilər,bunların,xanımlar,yeri,doğum,yaşında,alıb,təhlükəli,inanmıram,eyni ,anlayır,getmərəm,adına,tez,sıx,adını,yoxdur,bir çox,səs,gözləyir,həyatını,özü,vaxt,elə,edəcəm,mühafizə,edərəm,içki,baxma,canlı,kapitan,anlamıram,musiqi,vəziyyəti,mənasız,xatırlayır,otaq,kimsən,demə,sonrakı,qırmızı,güc,gəldik,dost,verir,təmiz,bilmirəm,dostun,fikirləşir,yu,günlər,aşiq,bilmirdim,heç kimin,sıra,olmağını,olduğum,tapdın,etmərəm,zamanlar,edək,üstündə,mənə bax,uşaqları,olduğun,birdən,olsaydı,gəlib,insanları,istədiyin,gözləyin,sonsuza,nə üçün,ikinci,yerində,məclis,danış,işim,bir şeylər,almağa,qızın,danışma,mövzu,göstər,işlər,sevir,sonu,əsil,qara,hörmətli,yanına,gəldiniz,bilirik,alacağam,yaxşıyam,haqlı,soyuq,haqq,danışırsan,lazımdır,buradakı,sərt,buranı,tapmaq,getsin,tərəfə,olmağa,siqaret,dəfə,müdir,olmasın,qulaq asın,yaxşısı,heç kimə,xüsusilə,bilik,yeməyi,cənablar,adamlar,istəyirsən,seçmək,bacararam,bir nəfərlə,təcili,general,işini,aid,olduqca,qalın,hamınız,avtomobili,deyirəm,olma,bağlı,eşidir,həqiqəti,alar,tərəfdən,öldürmək,rədd ol,işə,yerini,qüsura,baxmayaraq,atamın,canına,deyim,tanıyır,yola,onlarla,narkotik,atası,mənası,onlardan,bağışlayasınız,görmədim,istəmir,kitab,deyilik,daxil,baxım,yaşayır,gir,ora,bizdən,edəbilər,təslim,çoxu,salamat qal,qapı,dua,komanda,adın,qalan,bağla,səbəbə,gəlmək,silahlı,şəhər,dürüst,hissəsi,məcburam,özüm,işləyirsən,qürur,cəhənnəmə,zəngin,xoşuma,ağır,özümə,görməyə,səkkiz,mesaj,qalmaq,sıx,məktəb,gedər`;
    if (this.$i18n.locale == "ru") {
      this.words = [
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 6),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 7),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 8),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 9),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length > 10),
        ],
      ];
    }

    if (this.$i18n.locale == "az") {
      this.words = [
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 6),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 7),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 8),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 9),
        ],
        [
          ...az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length > 10),
        ],
      ];
    }

    if (this.config != undefined && this.config != null) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.row != null && this.config.row != "")
        this.row = Math.max(this.config.row, 20);
      if (this.config.col != null && this.config.col != "")
        this.col = this.config.col;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  margin-top: 20px;
}

.is-dark {
  #goz_esnetme {
    background: black;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/IkiliUcluBlok.vue